<template>
    <div>
       <div :style="{ color: color }">
            <!-- {{timeSince(new Date(data.invoiceDueDate))}} -->
            {{data.status === 'Paid' ? '-' : timeSince(new Date(data.invoiceDueDate))}}
       </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            data: {},
            color: ''
        }
    },
    methods: {
        timeSince(date) {
            let seconds = Math.floor((new Date() - date) / 1000);
            const value = seconds < 0 ? 'from now' : 'ago'
            this.color = seconds < 0 ? 'green' : 'red'
            seconds = Math.abs(seconds)

            var interval = seconds / 31536000;

            if (interval > 1) {
                return Math.floor(interval) + (Math.floor(interval) == 1 ? " year " : " years ") + value;
            }
            interval = seconds / 2592000;
            if (interval > 1) {
                return Math.floor(interval) + (Math.floor(interval) == 1 ? " month " : " months ") + value;
            }
            interval = seconds / 86400;
            if (interval > 1) {
                return Math.floor(interval) + (Math.floor(interval) == 1 ? " day " : " days ") + value;
            }
            interval = seconds / 3600;
            if (interval > 1) {
                return Math.floor(interval) + (Math.floor(interval) == 1 ? " hour " : " hours ") + value;
            }
            interval = seconds / 60;
            if (interval > 1) {
                return Math.floor(interval) + (Math.floor(interval) == 1 ? " minute " : " minutes ") + value;
            }
            return Math.floor(seconds) + (Math.floor(interval) == 1 ? " second " : " seconds ") + value;
        },
    }
 }
</script>